import { Color, Rgba } from '../types/color';
import { Stamp } from '../drawing/types';

export const imageTileSize = 128;
export const drawingAreaMargin = 512;

// シートサイズにこの倍率をかけたものがCanvasの基準サイズとなる
export const fundamentalSizeMultiplier = 2;

export const textBoxDefaultFontSize = 32;
export const textBoxDefaultPaddingSize = 32;

export const colorPalette: { [key in Color]: Rgba } = {
  Red: { red: 214, green: 8, blue: 12, alpha: 1 },
  Blue: { red: 49, green: 57, blue: 201, alpha: 1 },
  Yellow: { red: 250, green: 250, blue: 0, alpha: 1 },
  Green: { red: 55, green: 153, blue: 55, alpha: 1 },
  Black: { red: 0, green: 0, blue: 0, alpha: 1 },
  White: { red: 255, green: 255, blue: 255, alpha: 1 },

  Transparent: { red: 0, green: 0, blue: 0, alpha: 0 },
  RedTransparent: { red: 214, green: 8, blue: 12, alpha: 0.5 },
  BlueTransparent: { red: 49, green: 57, blue: 201, alpha: 0.5 },
  YellowTransparent: { red: 250, green: 250, blue: 0, alpha: 0.5 },
  GreenTransparent: { red: 55, green: 153, blue: 55, alpha: 0.5 },
  BlackTransparent: { red: 0, green: 0, blue: 0, alpha: 0.5 },
  WhiteTransparent: { red: 255, green: 255, blue: 255, alpha: 0.5 },
};

export const sneCustomColors: { [key: string]: Rgba[] } = {
  out:[
    { red: 0, green: 0, blue: 0, alpha: 1 },
    { red: 67, green: 67, blue: 67, alpha: 1 },
    { red: 102, green: 102, blue: 102, alpha: 1 },
    { red: 153, green: 153, blue: 153, alpha: 1 },
    { red: 183, green: 183, blue: 183, alpha: 1 },
    { red: 204, green: 204, blue: 204, alpha: 1 },
    { red: 217, green: 217, blue: 217, alpha: 1 },
    { red: 239, green: 239, blue: 239, alpha: 1 },
    { red: 243, green: 243, blue: 243, alpha: 1 },
    { red: 255, green: 255, blue: 255, alpha: 1 },

    { red: 150, green: 4, blue: 12, alpha: 1 },
    { red: 252, green: 13, blue: 28, alpha: 1 },
    { red: 253, green: 152, blue: 39, alpha: 1 },
    { red: 255, green: 253, blue: 56, alpha: 1 },
    { red: 41, green: 253, blue: 47, alpha: 1 },
    { red: 45, green: 254, blue: 254, alpha: 1 },
    { red: 77, green: 136, blue: 229, alpha: 1 },
    { red: 25, green: 49, blue: 251, alpha: 1 },
    { red: 152, green: 38, blue: 251, alpha: 1 },
    { red: 253, green: 41, blue: 252, alpha: 1 },

    { red: 229, green: 184, blue: 176, alpha: 1 },
    { red: 243, green: 204, blue: 205, alpha: 1 },
    { red: 251, green: 229, blue: 206, alpha: 1 },
    { red: 255, green: 242, blue: 206, alpha: 1 },
    { red: 218, green: 234, blue: 212, alpha: 1 },
    { red: 209, green: 224, blue: 227, alpha: 1 },
    { red: 202, green: 219, blue: 247, alpha: 1 },
    { red: 208, green: 226, blue: 242, alpha: 1 },
    { red: 217, green: 211, blue: 232, alpha: 1 },
    { red: 234, green: 210, blue: 220, alpha: 1 },

    { red: 219, green: 126, blue: 109, alpha: 1 },
    { red: 233, green: 153, blue: 154, alpha: 1 },
    { red: 248, green: 203, blue: 159, alpha: 1 },
    { red: 254, green: 228, blue: 157, alpha: 1 },
    { red: 183, green: 214, blue: 170, alpha: 1 },
    { red: 163, green: 196, blue: 201, alpha: 1 },
    { red: 165, green: 195, blue: 242, alpha: 1 },
    { red: 160, green: 198, blue: 231, alpha: 1 },
    { red: 180, green: 168, blue: 213, alpha: 1 },
    { red: 212, green: 167, blue: 189, alpha: 1 },

    { red: 202, green: 66, blue: 45, alpha: 1 },
    { red: 222, green: 102, blue: 104, alpha: 1 },
    { red: 245, green: 177, blue: 112, alpha: 1 },
    { red: 254, green: 216, blue: 110, alpha: 1 },
    { red: 148, green: 195, blue: 128, alpha: 1 },
    { red: 119, green: 165, blue: 174, alpha: 1 },
    { red: 111, green: 160, blue: 233, alpha: 1 },
    { red: 113, green: 169, blue: 218, alpha: 1 },
    { red: 142, green: 125, blue: 193, alpha: 1 },
    { red: 193, green: 124, blue: 159, alpha: 1 },

    { red: 164, green: 30, blue: 15, alpha: 1 },
    { red: 223, green: 8, blue: 19, alpha: 1 },
    { red: 228, green: 144, blue: 66, alpha: 1 },
    { red: 240, green: 193, blue: 67, alpha: 1 },
    { red: 107, green: 167, blue: 83, alpha: 1 },
    { red: 71, green: 129, blue: 141, alpha: 1 },
    { red: 63, green: 122, blue: 213, alpha: 1 },
    { red: 65, green: 134, blue: 196, alpha: 1 },
    { red: 102, green: 81, blue: 165, alpha: 1 },
    { red: 164, green: 78, blue: 120, alpha: 1 },

    { red: 131, green: 33, blue: 19, alpha: 1 },
    { red: 165, green: 4, blue: 12, alpha: 1 },
    { red: 178, green: 94, blue: 26, alpha: 1 },
    { red: 190, green: 143, blue: 31, alpha: 1 },
    { red: 8, green: 139, blue: 0, alpha: 1 },
    { red: 23, green: 79, blue: 91, alpha: 1 },
    { red: 25, green: 88, blue: 201, alpha: 1 },
    { red: 18, green: 84, blue: 146, alpha: 1 },
    { red: 53, green: 33, blue: 115, alpha: 1 },
    { red: 114, green: 30, blue: 71, alpha: 1 },

    { red: 90, green: 15, blue: 4, alpha: 1 },
    { red: 120, green: 2, blue: 5, alpha: 1 },
    { red: 119, green: 63, blue: 15, alpha: 1 },
    { red: 126, green: 95, blue: 17, alpha: 1 },
    { red: 56, green: 97, blue: 39, alpha: 1 },
    { red: 15, green: 52, blue: 60, alpha: 1 },
    { red: 31, green: 71, blue: 133, alpha: 1 },
    { red: 11, green: 56, blue: 97, alpha: 1 },
    { red: 32, green: 21, blue: 75, alpha: 1 },
    { red: 75, green: 18, blue: 48, alpha: 1 },
  ],
  over:
  [
    { red: 51, green: 51, blue: 51, alpha: 1 },
    { red: 105, green: 105, blue: 105, alpha: 1 },
    { red: 133, green: 133, blue: 133, alpha: 1 },
    { red: 173, green: 173, blue: 173, alpha: 1 },
    { red: 197, green: 197, blue: 197, alpha: 1 },
    { red: 214, green: 214, blue: 214, alpha: 1 },
    { red: 225, green: 225, blue: 225, alpha: 1 },
    { red: 242, green: 242, blue: 242, alpha: 1 },
    { red: 245, green: 245, blue: 245, alpha: 1 },
    { red: 255, green: 255, blue: 255, alpha: 1 },

    { red: 171, green: 54, blue: 61, alpha: 1 },
    { red: 253, green: 61, blue: 73, alpha: 1 },
    { red: 253, green: 173, blue: 82, alpha: 1 },
    { red: 255, green: 253, blue: 96, alpha: 1 },
    { red: 84, green: 253, blue: 89, alpha: 1 },
    { red: 87, green: 254, blue: 254, alpha: 1 },
    { red: 113, green: 160, blue: 234, alpha: 1 },
    { red: 71, green: 90, blue: 252, alpha: 1 },
    { red: 173, green: 81, blue: 252, alpha: 1 },
    { red: 253, green: 84, blue: 253, alpha: 1 },

    { red: 243, green: 198, blue: 192, alpha: 1 },
    { red: 245, green: 214, blue: 215, alpha: 1 },
    { red: 252, green: 234, blue: 216, alpha: 1 },
    { red: 255, green: 245, blue: 216, alpha: 1 },
    { red: 225, green: 238, blue: 221, alpha: 1 },
    { red: 218, green: 230, blue: 233, alpha: 1 },
    { red: 213, green: 226, blue: 249, alpha: 1 },
    { red: 217, green: 232, blue: 245, alpha: 1 },
    { red: 225, green: 220, blue: 237, alpha: 1 },
    { red: 238, green: 219, blue: 227, alpha: 1 },

    { red: 226, green: 152, blue: 138, alpha: 1 },
    { red: 237, green: 173, blue: 174, alpha: 1 },
    { red: 249, green: 213, blue: 178, alpha: 1 },
    { red: 254, green: 233, blue: 177, alpha: 1 },
    { red: 197, green: 222, blue: 187, alpha: 1 },
    { red: 181, green: 208, blue: 212, alpha: 1 },
    { red: 183, green: 207, blue: 245, alpha: 1 },
    { red: 179, green: 209, blue: 236, alpha: 1 },
    { red: 195, green: 185, blue: 221, alpha: 1 },
    { red: 221, green: 185, blue: 202, alpha: 1 },

    { red: 213, green: 104, blue: 87, alpha: 1 },
    { red: 229, green: 133, blue: 134, alpha: 1 },
    { red: 247, green: 193, blue: 141, alpha: 1 },
    { red: 254, green: 224, blue: 139, alpha: 1 },
    { red: 169, green: 207, blue: 153, alpha: 1 },
    { red: 146, green: 183, blue: 190, alpha: 1 },
    { red: 140, green: 179, blue: 237, alpha: 1 },
    { red: 141, green: 186, blue: 225, alpha: 1 },
    { red: 165, green: 151, blue: 205, alpha: 1 },
    { red: 205, green: 150, blue: 178, alpha: 1 },

    { red: 182, green: 75, blue: 63, alpha: 1 },
    { red: 229, green: 57, blue: 66, alpha: 1 },
    { red: 233, green: 166, blue: 104, alpha: 1 },
    { red: 243, green: 205, blue: 105, alpha: 1 },
    { red: 137, green: 185, blue: 117, alpha: 1 },
    { red: 108, green: 154, blue: 164, alpha: 1 },
    { red: 101, green: 149, blue: 221, alpha: 1 },
    { red: 103, green: 158, blue: 208, alpha: 1 },
    { red: 133, green: 116, blue: 183, alpha: 1 },
    { red: 182, green: 113, blue: 147, alpha: 1 },

    { red: 156, green: 77, blue: 66, alpha: 1 },
    { red: 183, green: 54, blue: 61, alpha: 1 },
    { red: 193, green: 126, blue: 72, alpha: 1 },
    { red: 203, green: 165, blue: 76, alpha: 1 },
    { red: 57, green: 162, blue: 51, alpha: 1 },
    { red: 69, green: 114, blue: 124, alpha: 1 },
    { red: 71, green: 121, blue: 212, alpha: 1 },
    { red: 65, green: 118, blue: 168, alpha: 1 },
    { red: 93, green: 77, blue: 143, alpha: 1 },
    { red: 142, green: 75, blue: 108, alpha: 1 },

    { red: 123, green: 63, blue: 54, alpha: 1 },
    { red: 147, green: 53, blue: 55, alpha: 1 },
    { red: 146, green: 101, blue: 63, alpha: 1 },
    { red: 152, green: 127, blue: 65, alpha: 1 },
    { red: 96, green: 129, blue: 82, alpha: 1 },
    { red: 63, green: 93, blue: 99, alpha: 1 },
    { red: 76, green: 108, blue: 157, alpha: 1 },
    { red: 60, green: 96, blue: 129, alpha: 1 },
    { red: 77, green: 68, blue: 111, alpha: 1 },
    { red: 111, green: 65, blue: 89, alpha: 1 },
  ],
  selected:
  [
    { red: 153, green: 153, blue: 153, alpha: 1 },
    { red: 180, green: 180, blue: 180, alpha: 1 },
    { red: 194, green: 194, blue: 194, alpha: 1 },
    { red: 214, green: 214, blue: 214, alpha: 1 },
    { red: 226, green: 226, blue: 226, alpha: 1 },
    { red: 235, green: 235, blue: 235, alpha: 1 },
    { red: 240, green: 240, blue: 240, alpha: 1 },
    { red: 249, green: 249, blue: 249, alpha: 1 },
    { red: 250, green: 250, blue: 250, alpha: 1 },
    { red: 255, green: 255, blue: 255, alpha: 1 },

    { red: 213, green: 155, blue: 158, alpha: 1 },
    { red: 254, green: 158, blue: 164, alpha: 1 },
    { red: 254, green: 214, blue: 169, alpha: 1 },
    { red: 255, green: 254, blue: 175, alpha: 1 },
    { red: 169, green: 254, blue: 172, alpha: 1 },
    { red: 171, green: 255, blue: 255, alpha: 1 },
    { red: 184, green: 207, blue: 245, alpha: 1 },
    { red: 163, green: 173, blue: 253, alpha: 1 },
    { red: 214, green: 168, blue: 253, alpha: 1 },
    { red: 254, green: 169, blue: 254, alpha: 1 },

    { red: 245, green: 227, blue: 223, alpha: 1 },
    { red: 250, green: 235, blue: 235, alpha: 1 },
    { red: 253, green: 245, blue: 235, alpha: 1 },
    { red: 255, green: 250, blue: 235, alpha: 1 },
    { red: 240, green: 247, blue: 238, alpha: 1 },
    { red: 237, green: 243, blue: 244, alpha: 1 },
    { red: 234, green: 241, blue: 252, alpha: 1 },
    { red: 236, green: 243, blue: 250, alpha: 1 },
    { red: 240, green: 237, blue: 246, alpha: 1 },
    { red: 247, green: 237, blue: 241, alpha: 1 },

    { red: 241, green: 203, blue: 197, alpha: 1 },
    { red: 246, green: 214, blue: 215, alpha: 1 },
    { red: 252, green: 234, blue: 217, alpha: 1 },
    { red: 255, green: 244, blue: 216, alpha: 1 },
    { red: 226, green: 239, blue: 221, alpha: 1 },
    { red: 218, green: 231, blue: 250, alpha: 1 },
    { red: 219, green: 231, blue: 250, alpha: 1 },
    { red: 217, green: 232, blue: 245, alpha: 1 },
    { red: 225, green: 220, blue: 238, alpha: 1 },
    { red: 238, green: 220, blue: 229, alpha: 1 },

    { red: 234, green: 179, blue: 171, alpha: 1 },
    { red: 242, green: 194, blue: 195, alpha: 1 },
    { red: 251, green: 224, blue: 198, alpha: 1 },
    { red: 255, green: 239, blue: 197, alpha: 1 },
    { red: 212, green: 231, blue: 204, alpha: 1 },
    { red: 201, green: 219, blue: 223, alpha: 1 },
    { red: 197, green: 217, blue: 246, alpha: 1 },
    { red: 198, green: 221, blue: 240, alpha: 1 },
    { red: 210, green: 203, blue: 230, alpha: 1 },
    { red: 230, green: 203, blue: 217, alpha: 1 },

    { red: 219, green: 165, blue: 159, alpha: 1 },
    { red: 242, green: 156, blue: 161, alpha: 1 },
    { red: 244, green: 211, blue: 179, alpha: 1 },
    { red: 249, green: 230, blue: 180, alpha: 1 },
    { red: 196, green: 220, blue: 186, alpha: 1 },
    { red: 181, green: 205, blue: 209, alpha: 1 },
    { red: 178, green: 202, blue: 238, alpha: 1 },
    { red: 179, green: 207, blue: 231, alpha: 1 },
    { red: 194, green: 185, blue: 219, alpha: 1 },
    { red: 219, green: 184, blue: 201, alpha: 1 },

    { red: 205, green: 166, blue: 161, alpha: 1 },
    { red: 219, green: 155, blue: 158, alpha: 1 },
    { red: 224, green: 191, blue: 163, alpha: 1 },
    { red: 229, green: 210, blue: 165, alpha: 1 },
    { red: 156, green: 209, blue: 153, alpha: 1 },
    { red: 162, green: 185, blue: 189, alpha: 1 },
    { red: 163, green: 188, blue: 233, alpha: 1 },
    { red: 160, green: 187, blue: 211, alpha: 1 },
    { red: 174, green: 166, blue: 199, alpha: 1 },
    { red: 199, green: 165, blue: 181, alpha: 1 },

    { red: 189, green: 159, blue: 155, alpha: 1 },
    { red: 201, green: 154, blue: 155, alpha: 1 },
    { red: 201, green: 178, blue: 159, alpha: 1 },
    { red: 203, green: 191, blue: 160, alpha: 1 },
    { red: 175, green: 192, blue: 169, alpha: 1 },
    { red: 159, green: 174, blue: 177, alpha: 1 },
    { red: 165, green: 181, blue: 206, alpha: 1 },
    { red: 157, green: 175, blue: 192, alpha: 1 },
    { red: 166, green: 161, blue: 183, alpha: 1 },
    { red: 183, green: 160, blue: 172, alpha: 1 },
  ],
};

export const defaultStamps: ReadonlyArray<Stamp> = [
  {
    id: '__viewer_default_stamp01',
    name: 'ビューアスタンプ01',
    width: 128,
    height: 128,
    path: 'images/default_stamp/default_stamp01.png',
  },
  {
    id: '__viewer_default_stamp02',
    name: 'ビューアスタンプ02',
    width: 128,
    height: 128,
    path: 'images/default_stamp/default_stamp02.png',
  },
  {
    id: '__viewer_default_stamp03',
    name: 'ビューアスタンプ03',
    width: 128,
    height: 128,
    path: 'images/default_stamp/default_stamp03.png',
  },
  {
    id: '__viewer_default_stamp04',
    name: 'ビューアスタンプ04',
    width: 128,
    height: 128,
    path: 'images/default_stamp/default_stamp04.png',
  },
  {
    id: '__viewer_default_stamp05',
    name: 'ビューアスタンプ05',
    width: 128,
    height: 128,
    path: 'images/default_stamp/default_stamp05.png',
  },
  {
    id: '__viewer_default_stamp06',
    name: 'ビューアスタンプ06',
    width: 128,
    height: 128,
    path: 'images/default_stamp/default_stamp06.png',
  },
  {
    id: '__viewer_default_stamp07',
    name: 'ビューアスタンプ07',
    width: 128,
    height: 128,
    path: 'images/default_stamp/default_stamp07.png',
  },
  {
    id: '__viewer_default_stamp08',
    name: 'ビューアスタンプ08',
    width: 128,
    height: 128,
    path: 'images/default_stamp/default_stamp08.png',
  },
  {
    id: '__viewer_default_stamp09',
    name: 'ビューアスタンプ09',
    width: 128,
    height: 128,
    path: 'images/default_stamp/default_stamp09.png',
  },
  {
    id: '__viewer_default_stamp10',
    name: 'ビューアスタンプ10',
    width: 128,
    height: 128,
    path: 'images/default_stamp/default_stamp10.png',
  },
];
